__turbopack_context__.v({
  "action": "CallPopup-module-scss-module__fEzSNq__action",
  "draggableWrapper": "CallPopup-module-scss-module__fEzSNq__draggableWrapper",
  "main": "CallPopup-module-scss-module__fEzSNq__main",
  "person": "CallPopup-module-scss-module__fEzSNq__person",
  "personImg": "CallPopup-module-scss-module__fEzSNq__personImg",
});
